import { useModulesContext } from '../context/ModulesContext.js';
/**
 * Returns all resolved module instances, or only those matching `slug` when provided.
 */
export function useAvailableInstances(slug) {
    const { instances } = useModulesContext();
    if (!slug)
        return instances;
    return instances.filter((i) => i.slug === slug);
}
//# sourceMappingURL=useAvailableInstances.js.map